import {ACTION_CODE} from './_actionCode';
import {TrainingSpecialitiesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_TRAINING_SPECIALITIES';

export async function getAllTrainingSpecialities(
    userData: UserState["userProfileData"],
    params = "",
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllTrainingSpecialities - Start');

        const getAllTrainingSpecialitiesResult = await TrainingSpecialitiesService.getAllTrainingSpecialities(userData, params, page);

        LoggerService.logInfo('Action - getAllTrainingSpecialities - Success');

        return ResultModel.newSuccessResult(getAllTrainingSpecialitiesResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllTrainingSpecialities - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des spécialités de formation',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
